// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__BDwnV","inner":"Table_inner__8unjT","table-action":"Table_table-action__bKp-i"};